<template lang="pug">
  .component-client-smart-edit(v-if="$acl('edit-clients')")
    smart-edit(:options="options", :value="item", @input="updateFields")
    button.button.expanded(v-on:click="edit") Save and Submit
  h3(v-else) Your account doesn't have permission to edit clients.
</template>
<script type="text/babel">
  import SmartEdit from 'components/structure/SmartEdit'
  import KeplerBackofficeSdk from 'src/lib/kepler/backoffice'
  import MaggieHelper from '../../../maggieHelper'
  import {mapState} from 'vuex'

  export default {
    name: 'ClientSmartEdit',
    components: {SmartEdit},
    data() {
      return {
        clientTypes: [],
        test: [],
        items: null,
        options: {
          types: {
            'client_type.code': []
          },
          translations: {},
          disabled: [
            'id',
            'profile_picture',
            'status',
            'created',
          ],
          list: [
            'id',
            'client_type.id',
            'client_type.type',
            'status',
            'uid',
            'wallet',
            'payment_methods',
            'main_driver',
            'drivers',
            'created',

          ],
          listMode: 'blacklist',
        }
      }
    },
    created() {
      KeplerBackofficeSdk.clientTypes.list(1, 1000, null).all((data) => {
        this.clientTypes = data.clientTypes
        this.options.types['client_type.code'] = data.clientTypes.map((item) => {
          return item.code
        })
      })

      this.configuration.system.system_client_custom_fields.value.forEach((item) => {
        if (this.item.extra === null) {
          this.$set(this.item, 'extra', {})
        }

        if (typeof this.item.extra[item.value] === 'undefined') {
          this.$set(this.item.extra, item.value, null)
        }
      })
    },
    methods: {
      updateFields(item) {
        this.item = item
      },
      edit() {

        var client_type_id = this.item.client_type.id
        this.clientTypes.forEach((item) => {
          if (item.code === this.item.client_type.code) {
            client_type_id = item.id
          }
        })

        this.$set(this.item, 'client_type_id', client_type_id)
        KeplerBackofficeSdk.clients.select(this.item.id).edit(this.item, () => {


          MaggieHelper.notification('edit-esit', 'Client edited successfully')
          MaggieHelper.closeRightPanel()
          this.$emit('updated')
          //location.reload()
        })
      }
    },
    props: [
      'item'
    ],
    computed: {
      ...mapState({
        configuration: state => state.configuration,
      })
    }
  }
</script>
<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// ClientEdit.vue?e13cbd1c